var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccomplishments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    width: 26,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.55 11.232c6.104 0 11.052-5.029 11.052-11.232H1.5c0 6.203 4.948 11.232 11.05 11.232zM6.21 18.116h12.682V25H6.21z",
    fill: "#60B6B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.108 11.232h6.884v6.884H9.108z",
    fill: "#335280"
  })));
}
export default SvgAccomplishments;